import { PriceRow } from "@/interfaces/PriceRow";
import { defineComponent, onMounted, PropType } from "vue";
import gsap from "gsap";

export default defineComponent({
  props: {
    title: { type: String, required: false },
    text: { type: String, required: false },
    extraTitle: { type: String, required: false },
    extraText: { type: String, required: false },
    prices: { type: Array as PropType<PriceRow[]>, required: true },
  },
  setup() {
    const randomClassNameSuffix = Date.now(); // we don't have a wrapping html-element that we could reference with vue-ref. Therefore creating a random classname so multilple instances of this compoponent don't interfere.

    onMounted(() => {
      const currentDisplayTypeElementClassname = `.tickets__display_title-${randomClassNameSuffix}`;
      const displayTypeElement = document.querySelector(
        currentDisplayTypeElementClassname
      );

      if (displayTypeElement) {
        const displayTypeLines =
          displayTypeElement.querySelectorAll(".nmm_title__line");

        if (displayTypeLines) {
          gsap
            .timeline({
              scrollTrigger: {
                trigger: currentDisplayTypeElementClassname,
                start: "top 100%",
              },
            })
            .from(displayTypeLines, {
              y: 100,
              duration: 1.6,
              ease: "power4.out",

              stagger: { amount: 0.25 },
            });
        }
      }
    });

    return { randomClassNameSuffix };
  },
});
